import { Box, Image, Link, Text } from "@chakra-ui/react";
import { getImage } from "../../helpers/global";
import { useAppSelector } from "../../redux/store";
import CustomText from "../CustomText";

const Footer: React.FC = () => {
  const { theme } = useAppSelector((state) => state.theme);
  const { survey } = useAppSelector((state) => state.survey);
  const whiteLabelComponent = survey?.teamWhiteLabelLink ? Link : Text;
  const sharedLinkProps = survey?.teamWhiteLabelLink
    ? {
        href: survey.teamWhiteLabelLink,
        _hover: { textDecoration: "none" },
      }
    : {};

  return (
    <Box position="absolute" right="0" bottom="0">
      <CustomText
        fontSize={{ base: "sm", md: "md" }}
        fontFamily="body"
        textAlign="right"
        display="flex"
        alignItems="center"
        gap={2}
        as={whiteLabelComponent}
        {...sharedLinkProps}
      >
        <Box as="span" color={theme.textColor}>
          Powered by
        </Box>
        {survey && survey.teamWhiteLabelAccount && survey.teamWhiteLabelLogo ? (
          <Box as={whiteLabelComponent} {...sharedLinkProps}>
            <Image maxH="50px" src={getImage(survey.teamWhiteLabelLogo)} />
          </Box>
        ) : survey &&
          survey.teamWhiteLabelAccount &&
          survey.teamWhiteLabelText ? (
          <CustomText
            fontSize={{ base: "14px", lg: "24px" }}
            fontFamily="body"
            textAlign="right"
            as={whiteLabelComponent}
            {...sharedLinkProps}
          >
            {survey.teamWhiteLabelText}
          </CustomText>
        ) : (
          <Box as="span" fontWeight="bold" color={theme.textColor}>
            Gather
          </Box>
        )}
      </CustomText>
    </Box>
  );
};

export default Footer;
